// ------------ about text scrolling
gsap.set(".fill-up-1", { yPercent: 100 });
  gsap.to(".fill-up-1", {
    duration: 1,
    // opacity: 1,
    yPercent: -100,
    scrollTrigger: {
      trigger: ".splitText-section",
      start: "top",
      end: "bottom",
      anticipatePin: true,
      scrub: true,
      markers: false
    },
  });
  
  
  gsap.set(".fill-up-2", { yPercent: 100 });
  gsap.to(".fill-up-2", {
    duration: 1,
    // opacity: 1,
    yPercent: -100,
    scrollTrigger: {
      trigger: ".splitText-section",
      start: "top",
      end: 'bottom',
      scrub: true,
      anticipatePin: true,
      markers: false
    },
  });

  const lt = gsap.timeline({
    scrollTrigger: {
      trigger: ".splitText-section",
      start: "top",
      end: "bottom",
      toggleActions: "play none none reverse",
      scrub: true,
      pin: true,
      markers: false,
      toggleClass: "active-section"
    }
  });
  lt.fromTo(".splitText--0", { duration: 0.1, y: 0, opacity: 1 }, { duration: 0.1, y: -5, opacity: 0 })
    .fromTo(".splitText-0", { duration: 0.1, y: 0, opacity: 1 }, { duration: 0.1, y: -5, opacity: 0 })
    .fromTo(".splitText-1", { duration: 0.1, y: 0, opacity: 1 }, { duration: 0.1, y: -5, opacity: 0 })
    .fromTo(".splitText-2", { duration: 0.1, y: 0, opacity: 1 }, { duration: 0.1, y: -5, opacity: 0 })
    .fromTo(".splitText-3", { duration: 0.1, y: 0, opacity: 1 }, { duration: 0.1, y: -5, opacity: 0 });


gsap.utils.toArray(".about-section-parallax").forEach(function(container) {
    // Select both .image1 and .image2 inside the container
    let images = container.querySelectorAll(".image1, .image2");
  
    // Loop through each image (both .image1 and .image2)
    images.forEach(function(image) {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: container,
                scrub: true,
                pin: false,
                markers: false,
            },
        });

        // Apply animation to each image separately
        tl.from(image, {
            yPercent: 40,
            ease: "none",
        }).to(image, {
            yPercent: -40,
            ease: "none",
        });
    });
});


// ------------ home hero box animation
console.clear();
gsap.registerPlugin(ScrollTrigger);


function updatePadding() {
    const productGrid = document.querySelector(".collection-productgrid");
    if (productGrid) {
        if (window.innerWidth >= 2000) {
            productGrid.style.paddingRight = "150px";
        } else if (window.innerWidth >= 1700) {
            productGrid.style.paddingRight = "100px";
        } else if (window.innerWidth >= 1400) {
            productGrid.style.paddingRight = "40px";
        } else if (window.innerWidth >= 1200) {
            productGrid.style.paddingRight = "15px";
        } else {
            productGrid.style.paddingRight = "15px";
        }
    }
}

// Call on load and resize
updatePadding();
window.addEventListener("resize", updatePadding);

if (document.querySelector(".product-look-section-main")) {
    const totalSlides = document.querySelectorAll(".collection-collage__item").length;

    // Set visible slides to 3.5
    const visibleSlides = 3.5;
    const slideWidth = 100 / visibleSlides;

    // Target the external div where you want to add/remove the class
    const externalDiv = document.querySelector(".product-look");

     //document.querySelector(".collection-productgrid").style.paddingRight = "100px"; 
  
    // Animate the collection items
    gsap.utils.toArray(".collection-collage__item").forEach((item, index) => {
        // Determine y value based on the index
        let yValue;

        if (index === totalSlides - 1) {
            // Last slide: no movement
            //return; // Skip animation for the last slide
            yValue = -550;
        } else if (index === totalSlides - 2) {
            // Second last slide: move to -500
            yValue = -540;
        } else if (index === totalSlides - 3) {
            // Third last slide: move to -500
            yValue = -530;
        } else if (index === totalSlides - 4) {
            // Third last slide: move to -500
            yValue = -520;
        } else if (index === totalSlides - 5) {
            // Third last slide: move to -500
            yValue = -510;
        } else {
            // All other slides: move to -500
            yValue = -450;
        }

        // Apply animation for each applicable slide
        gsap.fromTo(item, 
            { 
                opacity: 1,
                y: 0,
            }, 
            { 
                opacity: 1,
                y: yValue, // Use the determined yValue
                ease: "power2.out",
                duration: 1,
                scrollTrigger: {
                    trigger: ".product-look-section-main",
                    start: `bottom+=${index * 60} bottom`,
                    end: "bottom top",
                    scrub: 1,
                    markers: false,
                    onUpdate: (self) => {
                        if (index === 0) { // Only check the first item
                            const transformValue = gsap.getProperty(item, "y"); // Get Y position of the first item
                            if (transformValue <= -300) {
                                externalDiv.classList.add("scroll-end");
                            } else {
                                externalDiv.classList.remove("scroll-end");
                            }
                        }
                    }
                }
            }
        );
    });

  // Scroll-triggered animation for horizontal sliding
     gsap.to(".collection-productgrid", {
        xPercent: -(totalSlides - visibleSlides) * slideWidth,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger: ".product-look-section-main",
            pin: true,
            scrub: true,
            start: 'bottom bottom',
            end: () => "+=" + (document.querySelector(".collection-productgrid").scrollWidth * 0.5 - 800),
            markers: false
        }
    });
}



document.addEventListener("DOMContentLoaded", function() {
  const curcuminBaseURL = "https://cdn.shopify.com/s/files/1/0703/7763/6087/files/Curcumin-updated_";
  const CurcuminImages = Array.from({ length: 42 }, (_, i) => `${curcuminBaseURL}${String(i).padStart(3, '0')}.png`);

  const collagenBaseURL = "https://cdn.shopify.com/s/files/1/0703/7763/6087/files/Collagen-updated_";
  const CollagenImages = Array.from({ length: 42 }, (_, i) => `${collagenBaseURL}${String(i).padStart(3, '0')}.png`);

  const gingerBaseURL = "https://cdn.shopify.com/s/files/1/0703/7763/6087/files/Ginger-updated_";
  const GingerImages = Array.from({ length: 42 }, (_, i) => `${gingerBaseURL}${String(i).padStart(3, '0')}.png`);

  const liverpalBaseURL = "https://cdn.shopify.com/s/files/1/0703/7763/6087/files/Liverpal-updated_";
  const LiverpalImages = Array.from({ length: 42 }, (_, i) => `${liverpalBaseURL}${String(i).padStart(3, '0')}.png`);

  const standingoBaseURL = "https://cdn.shopify.com/s/files/1/0703/7763/6087/files/Standingo-updated_";
  const StandingoImages = Array.from({ length: 42 }, (_, i) => `${standingoBaseURL}${String(i).padStart(3, '0')}.png`);

  const toptearBaseURL = "https://cdn.shopify.com/s/files/1/0703/7763/6087/files/Toptear-updated_";
  const ToptearImages = Array.from({ length: 42 }, (_, i) => `${toptearBaseURL}${String(i).padStart(3, '0')}.png`);

  function dom(containerSelector, imageUrls) {
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Container not found for selector: ${containerSelector}. Skipping image loading.`);
      return;
    }

    const canvas = container.querySelector("canvas");
    const context = canvas.getContext("2d");
    const images = [];
    const imageSeq = { frame: 0 };
    const frameCount = imageUrls.length;

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = imageUrls[i];
      images.push(img);
    }

    images[0].onload = function () {
      adjustCanvasSize(images[0]);
      render();
    };

    window.addEventListener("resize", function () {
      adjustCanvasSize(images[imageSeq.frame]);
      render();
    });

    function adjustCanvasSize(img) {
      canvas.width = container.clientWidth;
      canvas.height = (img.height / img.width) * canvas.width;
    }

    const scrollTrigger = {
      scrub: 4,
      pin: true,
      trigger: containerSelector,
      start: "top 50px",
      end: () => `+=${canvas.clientHeight}`,
    };

    gsap.to(imageSeq, {
      frame: frameCount - 1,
      snap: "frame",
      ease: "none",
      scrollTrigger: scrollTrigger,
      onUpdate: render,
    });

    function render() {
      scaleImage(images[imageSeq.frame], context);
    }

    function scaleImage(img, ctx) {
      const canvas = ctx.canvas;
      const hRatio = canvas.width / img.width;
      const vRatio = canvas.height / img.height;
      const ratio = Math.min(hRatio, vRatio);
      const centerShift_x = (canvas.width - img.width * ratio) / 2;
      const centerShift_y = 0;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);
    }

    const items = gsap.utils.toArray(".content-section_grid_item");
    gsap.fromTo(
      items,
      { opacity: 0, x: (i) => ((i + 1) % 2 !== 0 ? -150 : 150) },
      {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: "power3.inOut",
        stagger: 0.2,
        scrollTrigger: {
          trigger: canvas,
          start: "70% top",
          end: "bottom bottom",
          scrub: 0.3,
        },
      }
    );
  }

  dom(".Curcumin-video-container", CurcuminImages);
  dom(".Collagen-video-container", CollagenImages);
  dom(".Ginger-video-container", GingerImages);
  dom(".Liverpal-video-container", LiverpalImages);
  dom(".Standingo-video-container", StandingoImages);
  dom(".Toptear-video-container", ToptearImages);
});
console.clear();


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product-media-modal__toggle").forEach(button => {
        button.addEventListener("click", function () {
            let featuredVideo = document.querySelector(".product-media-container.media-type-video video"); // Adjust selector if needed
            if (featuredVideo) {
                featuredVideo.play();
            }
        });
    });
});



/*
function waitForElement(selector, callback, timeout = 5000) {
    const start = Date.now();

    const check = () => {
      const element = document.querySelector(selector);
      if (element) {
        callback(element);
      } else if (Date.now() - start < timeout) {
        requestAnimationFrame(check);
      }
    };

    check();
  }

  waitForElement('#appstle-widget-template .appstle_input_wrapper:nth-child(1)', function (labelToWatch) {
    const priceInfo = document.querySelector('.price-detils-info');
    const onetimeBlock = document.querySelector('.appstle_input_wrapper.appstle_onetime_block');

    function updateVisibility() {
      const isActive = labelToWatch.classList.contains('appstle-active-option');

      if (priceInfo) {
        priceInfo.style.display = isActive ? 'block' : 'none';
      }

      if (priceInfo && onetimeBlock) {
        if (onetimeBlock.classList.contains('appstle-active-option')) {
          priceInfo.classList.add('month_1');
        } else {
          priceInfo.classList.remove('month_1');
        }
      }
    }

    updateVisibility();

    const observer = new MutationObserver(updateVisibility);

    observer.observe(labelToWatch, { attributes: true, attributeFilter: ['class'] });
    if (onetimeBlock) {
      observer.observe(onetimeBlock, { attributes: true, attributeFilter: ['class'] });
    }
  });
 */
// Nomada: show the full price on the Appstle one-time option (Appstle leaves it blank)
setInterval(function () { var w = document.getElementById('appstle_subscription_widget0'); if (!w) return; var c = w.querySelector('.appstle_sellingPlan_formattedCompareAtPrice'); var o = w.querySelector('.appstle_onetime_amount'); if (c && o && c.textContent.trim() && o.textContent.trim() !== c.textContent.trim()) { o.textContent = c.textContent.trim(); } }, 800);
// Nomada: mobile sticky add-to-cart bar (replaces the Square app) - mirrors the selected Appstle option and saving
(function () { var main = document.querySelector('.product__info-container .product-form__submit'); if (!main || !('IntersectionObserver' in window)) return; var bar = document.createElement('div'); bar.className = 'nsb'; bar.innerHTML = '<img class="nsb__img" alt=""><div class="nsb__info"><div class="nsb__title"></div><div class="nsb__price"><span class="nsb__now"></span><s class="nsb__was"></s><span class="nsb__save"></span></div></div><button type="button" class="nsb__btn">Add to cart</button>'; document.body.appendChild(bar); var h = document.querySelector('.product__title h1'); bar.querySelector('.nsb__title').textContent = h ? h.textContent.split(' — ')[0].trim() : ''; var im = document.querySelector('.product__media img'); if (im) { bar.querySelector('.nsb__img').src = im.currentSrc || im.src; } else { bar.querySelector('.nsb__img').style.display = 'none'; } var num = function (s) { return parseFloat((s || '').replace(/[^0-9.]/g, '')); }; var txt = function (el) { return el ? el.textContent.trim() : ''; }; var update = function () { var w = document.getElementById('appstle_subscription_widget0'); var a = w && w.querySelector('.appstle-active-option'); var now = '', was = '', save = ''; if (a && !a.classList.contains('appstle_onetime_block')) { now = txt(a.querySelector('.appstle_price_block.appstle_sellingPlan_price')); was = txt(a.querySelector('.appstle_sellingPlan_formattedCompareAtPrice')); if (num(now) && num(was) > num(now)) { save = 'Save ' + Math.round((1 - num(now) / num(was)) * 100) + '%'; } else { was = ''; } } else if (a) { now = txt(a.querySelector('.appstle_onetime_amount')); } if (!now) { now = txt(document.querySelector('.product__info-container .price-item--regular')); } bar.querySelector('.nsb__now').textContent = now; bar.querySelector('.nsb__was').textContent = was; bar.querySelector('.nsb__save').textContent = save; var b = bar.querySelector('.nsb__btn'); b.disabled = main.disabled; b.textContent = main.disabled ? 'Sold out' : 'Add to cart'; }; update(); setInterval(update, 600); bar.querySelector('.nsb__btn').addEventListener('click', function () { main.click(); }); new IntersectionObserver(function (e) { bar.classList.toggle('nsb--show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(main); })();